import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FiltroInformeContabilidadConsultas } from '../../model/informes';

@Injectable()
export class FileManagerService {

  static PATH = `${environment.API_BASE}/Files`;
  static PATH_OCR = `${environment.API_BASE}/OCR`;

  constructor(
    private http: HttpClient
  ) { }

  uploadFileToRepository(file: File, isTemporal: boolean, isDocumentFile: number): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<string>(`${FileManagerService.PATH}/${isTemporal}/${isDocumentFile}`, formData);
  }

  removeFileFromRepository(guid: string): Observable<number> {
    return this.http.delete<number>(`${FileManagerService.PATH}/${guid}`);
  }

  removeFilesOfContenidoFromRepository(idcontenido: number): Observable<number> {
    return this.http.get<number>(`${FileManagerService.PATH}/Contenido/${idcontenido}`);
  }

  downloadFileFromRepository(guid: string): Observable<any> {
    return this.http.get(`${FileManagerService.PATH}/${guid}`, { responseType: 'blob' });
  }

  downloadFileExportReport(filtro: FiltroInformeContabilidadConsultas, desde: number = 0, size: number = 10): Observable<any> {
    const uriLlamada = environment.API_BASE + '/Informes/ExportInformeContabilidadConsultas?from=' + desde + '&size=' + size;
    return this.http.post(uriLlamada, JSON.stringify(filtro), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    });
  }

  associateFileToRequest(idSolicitud: number, guid: string): Observable<any> {
    return this.http.post<any>(`${FileManagerService.PATH}/AssociateFileToSol/${guid}/${idSolicitud}`, undefined);
  }

  associateFileToContent(idContenido: number, guid: string): Observable<any> {
    return this.http.post<any>(`${FileManagerService.PATH}/AssociateFileToCon/${guid}/${idContenido}`, undefined);
  }

  associateFileToComment(idObservacion: number, guid: string): Observable<any> {
    return this.http.post<any>(`${FileManagerService.PATH}/AssociateFileToObs/${guid}/${idObservacion}`, undefined);
  }

  /* DDA   21/01/2019 => Para añadir un fichero nuevo al contenido de una solicitud, se debe realizar a través del OCR.
  El OCR, a través de la configuración del cliente, decide si realizar el OCR y subirlo al repositorio o
  al repositorio directamente. */

  addFileAndOCRToRepo(file: File, idContenido: number, idioma: string): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(`${FileManagerService.PATH_OCR}/UploadImageToRepo/${idContenido}`, formData);
  }

}
